import { render, staticRenderFns } from "./AddDistrict.vue?vue&type=template&id=3c2e55f0&scoped=true&"
import script from "./AddDistrict.vue?vue&type=script&lang=js&"
export * from "./AddDistrict.vue?vue&type=script&lang=js&"
import style0 from "./AddDistrict.vue?vue&type=style&index=0&id=3c2e55f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e55f0",
  null
  
)

export default component.exports